import React, { Component } from 'react';
import { connect } from 'react-redux';
import { routes } from 'constants/config';
import { Button } from 'components/ui';
import { initDefaultView } from 'actions/inPersonTraining/defaultView';
import supportsLocalStorage from 'utils/supportsLocalStorage';
import * as action from 'actions/shared/index/filter';
import IndexHeader from '../../shared/index/header';
import IndexTable from '../../shared/index/table';
import IndexWindowLocation from '../../shared/index/window_location';
import ArchiveButton from '../../shared/index/archive_button';
import EventsActionBar from './ActionBar';
import Filters from './Filters';
import ResultsTable from './Table';
import DataView from './DataView';
import Filter from '../../shared/index/filters';
import { getTableHeaders } from './tableHeaders';
import {
  dataFetch,
  fetchTrainers,
  fetchEventCreators,
} from '../../../actions/shared/index/data';

const actions = (
  <div className="Index-newButtonsContainer">
    <Button
      icon="add"
      url={routes.IN_PERSON_TRAINING.NEW_EVENT}
      aria-label="Add New Event Button"
      pendoClassName="trk_button_learning_new-event"
    >
      {t('in_person_training.events.new_event')}
    </Button>
  </div>
);

class EventsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meta: {
        policies: { canCreateEvents: {} },
      },
    };
    if (supportsLocalStorage) {
      props.initDefaultView();
    }
  }

  componentDidMount() {
    this.props.dataFetch();
    this.props.fetchTrainers();
    this.props.fetchEventCreators();
  }

  render() {
    const tableHeaders = getTableHeaders();
    return (
      <div className="Index">
        <IndexWindowLocation omitParam="per_page" />
        <IndexHeader
          title={t('training_events.events')}
          actions={this.state.meta.policies.canCreateEvents && actions}
        />
        <div className="Index-toolbar Index-toolbar--search p-16 bg-navy-dark fd-r m-jc-e">
          <Filter.Search
            className="IndexFilter-improved-search"
            value={this.props.selectedQuery}
            improvedSearch
            submitCallback={query => this.props.filterUpdateQuery(query)}
            overridePlaceholder={t('common.search_event_by_keyword_or_phrase')}
          />
        </div>
        <Filters />
        <EventsActionBar />
        <DataView tableHeaders={tableHeaders}>
          <IndexTable selectable={false} tableHeaders={tableHeaders}>
            <ResultsTable />
          </IndexTable>
          <ArchiveButton type="event" />
        </DataView>
      </div>
    );
  }
}

const mapStateToProps = ({ filter, meta }) => ({
  meta,
  selectedQuery: filter.query,
});

const mapDispatchToProps = {
  dataFetch,
  fetchTrainers,
  fetchEventCreators,
  initDefaultView,
  filterUpdateQuery: action.filterUpdateQuery,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsIndex);
